// -------- BREADCRUMB REQUIRE
import React from 'react';
import { Link, useLocation } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { APP_NAME } from '../../app.config';
// -------- BREADCRUMB REQUIRE END


// -------- BREADCRUMB
const useStylesBreadCrumb = makeStyles(theme => ({
    root: {
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    fontSize: {
        fontSize: '0.875rem',
    },
}));

const BreadcrumbsComponent = () => {
    const capitalize = (str) => {
        return str.toUpperCase();
    }
    const classes = useStylesBreadCrumb();
    let path: any = useLocation().pathname
    path = path === '/' ? [''] : path.split('/').filter((a) => a != "edit");
    let allPath = path.map((directive, i) => {
        return (path.length === 1 ?
            <Typography key={i} color="primary" className={classes.fontSize}>
                {capitalize(APP_NAME)}
            </Typography> : (i === 0) ?
                <Typography className={classes.fontSize} key={i}>
                    <Link className={classes.fontSize} style={{ textDecoration: 'none', color: 'unset' }} to='/'>
                        {capitalize(APP_NAME)}
                    </Link>
                </Typography> :
                (i !== path.length - 1 && i !== 0) ?
                    <Link className={classes.fontSize} key={i} color="primary" style={{ textDecoration: 'none', color: 'unset' }} to={'/' + path.slice(1, i + 1).join("/")}>
                        {capitalize(directive)}
                        </Link> :
                    <Typography key={i} color="primary" className={classes.fontSize}>
                        {capitalize(directive)}
                        </Typography>
        )
    })

    return (
        <div className={classes.root}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                {allPath}
            </Breadcrumbs>
        </div>
    )
}
// -------- END BREADCRUMB

export default (BreadcrumbsComponent)